import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/umob.webp';
import screenshot_target from '../../../images/letterfunnel/bibijorissen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Bibi Jorissen"
      firstname="Bibi"
      companyname="umob"
      competition="Gaiyo en 9292"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/bibijorissen.js